import { Config } from "../services/api";
import { AdFormI, AdvancedSearchI, DetailI } from "./dataConfigTypes";

import { mapModuleToEn } from "../routes/LanguageMapper";

export const getAdFormConfig = async (module: string) => {
  // TODO: Davor - Make request to get adFormConfig for specific module not all of them, because file is too big
  const adForm: AdFormI[] = await Config.UI("form.json");

  const adFormConfig = adForm.find(c => c.nameHr === module);

  if (!adFormConfig) {
    return adForm.find(c => c.name === "default");
  }

  return adFormConfig;
};

export const getAdvancedSearchConfig = async (module: string) => {
  const advancedSearch: AdvancedSearchI[] = await Config.UI(
    "advancedSearch.json"
  );

  const advancedSearchConfig = advancedSearch.find(
    c => c.name === mapModuleToEn(module)
  );

  if (!advancedSearchConfig) {
    return advancedSearch.find(c => c.name === "default");
  }

  return advancedSearchConfig;
};

export const getModuleAdvancedSearchConfig = async (module: string) => {
  const advancedSearch: AdvancedSearchI[] = await Config.UI(
    "advancedSearchModule.json"
  );

  const advancedSearchConfig = advancedSearch.find(
    c => c.name === mapModuleToEn(module)
  );

  if (!advancedSearchConfig) {
    return advancedSearch.find(c => c.name === "default");
  }

  return advancedSearchConfig;
};

export const getDetailConfig = async (module: string) => {
  const detail: DetailI[] = await Config.UI("detail.json");

  const detailConfig = detail.find(
    c => c.name === module || c.nameHr == module
  );

  if (!detailConfig) {
    return detail.find(c => c.name === "default");
  }

  return detailConfig;
};

export const getSummaryConfig = async (module: string) => {
  const summary: DetailI[] = await Config.UI("summary.json");
  const summaryConfig = summary.find(c => c.name === module);

  if (!summaryConfig) {
    return summary.find(c => c.name === "default");
  }

  return summaryConfig;
};



// WEBPACK FOOTER //
// ./src/dataConfig/index.ts